export const summaryConfig = [
	{
		"mobile": {
			"summaryDashboard": {
				// "available": {
				// 	"dbKey": "available",
				// 	"color": "#FFFFFF",
				// 	"countColor": "#000000",
				// 	"title": "Available",
				// 	"filter": "available"
				// },
				// "inUse": {
				// 	"dbKey": "inUse",
				// 	"color": "#FFFFFF",
				// 	"countColor": "#000000",
				// 	"title": "In Use",
				// 	"filter": "inUse"
				// },
				// "missing": {
				// 	"dbKey": "missing",
				// 	"color": "#FFFFFF",
				// 	"countColor": "#000000",
				// 	"title": "Missing",
				// 	"filter": "missing"
				// },
				"atRisk": {
					"dbKey": "atRisk",
					"color": "#FFFFFF",
					"countColor": "#000000",
					"title": "At Risk",
					"filter": "atRisk"
				},
				"lowBattery": {
					"dbKey": "lowBattery",
					"color": "#FFFFFF",
					"countColor": "#000000",
					"title": "Low Battery",
					"filter": "lowBattery"
				},
				"toBeFound": {
					"dbKey": "toBeFound",
					"color": "#FFFFFF",
					"countColor": "#000000",
					"title": "Missing",
					"filter": "toBeFound"
				},
				"charging": {
					"dbKey": "isCharging",
					"color": "#FFFFFF",
					"countColor": "#000000",
					"title": "Charging",
					"filter": "isCharging"
				},
				"notCharging": {
					"dbKey": "notCharging",
					"color": "#FFFFFF",
					"countColor": "#000000",
					"title": "Discharging",
					"filter": "notCharging"
				},
				"found": {
					"dbKey": "found",
					"color": "#FFFFFF",
					"countColor": "#000000",
					"title": "Found",
					"filter": "found"
				},
				"decommissioned": {
					"dbKey": "decommissioned",
					"color": "#FFFFFF",
					"countColor": "#000000",
					"title": "Decommissioned",
					"filter": "decommissioned"
				},
				"notConnected": {
					"dbKey": "notConnected",
					"color": "#FFFFFF",
					"countColor": "#000000",
					"title": "Disconnected",
					"filter": "notConnected"
				},
				"checkedOut": {
					"dbKey": "checkedOut",
					"color": "#FFFFFF",
					"countColor": "#000000",
					"title": "Checked Out",
					"filter": "checkedOut"
				},
				"idle": {
					"dbKey": "idle",
					"color": "#FFFFFF",
					"countColor": "#000000",
					"title": "Idle",
					"filter": "idle"
				}
			},
			"filter": {
				"toBeFound": {
					"deviceState": 1
				},
				"lowBattery": {
					"isCharging": false,
					"lowBattery": true
				},
				"active": {
					"deviceState": 0
				},
				"beingFound": {
					"deviceState": 2
				},
				"found": {
					"deviceState": 3
				},
				"notFound": {
					"deviceState": 4
				},
				"atRisk": {
					"deviceState": 5
				},
				"decommissioned": {
					"deviceState": 9999
				},
				"connected": {
					"connectionState": 1
				},
				"notConnected": {
					"connectionState": 2
				},
				"neverConnected": {
					"connectionState": 0
				},
				"checkedOut": {
					"checkOutState": true
				},
				"isCharging": {
					"isCharging": true
				},
				"idle": {
					"isIdle": true
				},
				"notCharging": {
					"isCharging": false
				}
			},
			"filterName": {
				"To Be Found": {
					"deviceState": 1
				},
				"In Service": {
					"deviceState": 0
				},
				"Being Found": {
					"deviceState": 2
				},
				"Found": {
					"deviceState": 3
				},
				"Cannot Find": {
					"deviceState": 4
				},
				"Decommissioned": {
					"deviceState": 9999
				},
				"At Risk": {
					"deviceState": 5
				},
			},
			"search": [
				{
					"searchKey": "friendlyName",
					"displayTitle": "Device Friendly Name"
				},
				{
					"searchKey": "modelNumber",
					"displayTitle": "Device Model"
				},
				{
					"searchKey": "serialNumber",
					"displayTitle": "Serial Number"
				},
				{
					"searchKey": "apFriendlyName",
					"displayTitle": "AP Friendly Name"
				},
				{
					"searchKey": "userId",
					"displayTitle": "Checkout Username"
				}
			]
		}
	},
	{
		"actionsToCode" : {
			"Mark Device for finding": {
				"0" : 1,
				"2" : 1,
				"3" : 1,
				"4" : 1,
				"5" : 1
			},
			"Mark device as InService" : {
				"1" : 0,
				"2" : 0,
				"4":  0,
				"3":  0,
				"5" : 0
			},
			"Cannot Find" : {
				"1" : 4,
				"2" : 4,
				"3" : 4,
			},
			"Check in Device" : [
				0, 1, 2, 3, 4 
			],
			"Recommission Device" : {
				"9999" : 0
			}, 
			"Decommission Device" : {
				"0" : 9999,
				"1" : 9999,
				"2" : 9999,
				"3" : 9999,
				"4" : 9999,
				"5" : 9999
			}
		}
	}
]